import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    title: string,
}

interface Variables {
    input: {
        description: string,
        title: string,
        waitTime: number,
    }
}

export const CREATE_NO_ACTION_STAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation CreateNoActionStage($input: NoActionAndApprovalInput){
        createNoActionStage(input: $input) {
            id
            title
            waitTime
        }
    }       
`
